import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  connect() { this.sync() }

  toggle() {
    this.trigger = document.activeElement
    if (this.mobile()) {
      document.documentElement.classList.toggle("sidebar-open")
      this.updateAccessibility()
      if (document.documentElement.classList.contains("sidebar-open")) this.element.querySelector("aside a, aside button")?.focus({ preventScroll: true })
      return
    }
    const collapsed = document.documentElement.classList.toggle("sidebar-collapsed")
    try { localStorage.setItem("sidebar-collapsed", collapsed ? "1" : "0") } catch (_) { /* storage is optional */ }
    this.updateAccessibility()
  }

  close() {
    const wasOpen = document.documentElement.classList.contains("sidebar-open")
    document.documentElement.classList.remove("sidebar-open")
    this.updateAccessibility()
    if (wasOpen) this.trigger?.focus({ preventScroll: true })
  }

  sync() {
    if (!this.mobile()) document.documentElement.classList.remove("sidebar-open")
    this.updateAccessibility()
  }

  trapFocus(event) {
    if (event.key !== "Tab" || !this.mobile() || !document.documentElement.classList.contains("sidebar-open")) return
    const controls = [...this.element.querySelectorAll("aside a[href], aside button:not(:disabled)")].filter((element) => element.getClientRects().length)
    const first = controls[0], last = controls[controls.length - 1]
    if (event.shiftKey && document.activeElement === first) { event.preventDefault(); last?.focus({ preventScroll: true }) }
    if (!event.shiftKey && document.activeElement === last) { event.preventDefault(); first?.focus({ preventScroll: true }) }
  }

  updateAccessibility() {
    const open = document.documentElement.classList.contains("sidebar-open")
    const sidebar = this.element.querySelector("[data-sidebar]")
    if (sidebar) sidebar.inert = this.mobile() && !open
    this.element.querySelectorAll("[data-sidebar-toggle]").forEach((toggle) => {
      toggle.setAttribute("aria-expanded", String(this.mobile() ? open : !document.documentElement.classList.contains("sidebar-collapsed")))
    })
  }

  disconnect() { document.documentElement.classList.remove("sidebar-open") }
  mobile() { return window.matchMedia("(max-width: 767px)").matches }
}
